module.exports = __webpack_public_path__ + "static/media/euta.335640a2.ogg";